import { defineComponent as _defineComponent } from 'vue'
import { lazyImageLabel, useLazyImage } from '@/features/ui/composables/useLazyImage';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderIconWide',
  props: {
    provider: { default: () => ({
			iconWide: 'https://static.justwatch.com/static/compile_jw/assets/jw-icon-badge.png',
			clearName: 'JustWatch',
		}) },
    loading: { default: 'lazy' }
  },
  setup(__props: any) {

const props = __props as { provider: {
			iconWide: string;
			clearName: string;
		}, loading: 'lazy' | 'eager' };



const { _el, isVisible } = useLazyImage(props.loading !== 'eager');

function iconUrl(format: 'avif' | 'webp' | 'jpeg') {
	const prefix = props.provider.iconWide.startsWith('/') ? JW_CONFIG.IMAGESCALER_URL : '';
	return prefix + props.provider.iconWide.replace('{format}', format);
}

return { __sfc: true,props, _el, isVisible, iconUrl, lazyImageLabel }
}

})